import { render } from "./TokenTransfer.vue?vue&type=template&id=11ec77be&scoped=true"
import script from "./TokenTransfer.vue?vue&type=script&lang=js"
export * from "./TokenTransfer.vue?vue&type=script&lang=js"

import "./TokenTransfer.vue?vue&type=style&index=0&id=11ec77be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ec77be"]])

export default __exports__